<div
  class="flex min-w-0 w-full flex-wrap items-baseline justify-start gap-x-2 gap-y-1 relative"
>
  <span class="min-w-0 max-w-full shrink-0 truncate font-semibold"
    >Created</span
  >

  <div class="flex flex-none items-baseline gap-2">
    <div class="relative">
      <button
        type="button"
        class="inline-flex items-center justify-center p-1 -mt-1 leading-none rounded hover:bg-surface-switch-200 hover:text-primary-500 cursor-pointer"
        [class.text-primary-500]="isFilterActive"
        (click)="toggleDropdown()"
      >
        <i [class]="isFilterActive ? 'pi pi-filter-fill' : 'pi pi-filter'"></i>
      </button>

      @if (dropdownOpen) {
        <div
          class="absolute top-full left-1/2 -translate-x-1/2 mt-2 z-20 min-w-[220px] rounded-md p-3 shadow-lg bg-surface-switch-0 border border-surface-switch-100"
        >
          <div class="space-y-3">
            <div>
              <label
                class="block text-sm font-medium text-surface-switch-900 mb-1"
                for="created-date-start"
                >Start date</label
              >
              <p-datepicker
                [(ngModel)]="dateRangeStart"
                inputId="created-date-start"
                placeholder="Start date"
                dateFormat="yy-mm-dd"
                showIcon
                (ngModelChange)="onStartChange($event)"
                [inputStyleClass]="'w-full px-2 py-1.5 rounded border border-surface-switch-200 bg-surface-switch-0 text-surface-switch-900 text-sm'"
              ></p-datepicker>
            </div>
            <div>
              <label
                class="block text-sm font-medium text-surface-switch-900 mb-1"
                for="created-date-end"
                >End date</label
              >
              <p-datepicker
                [(ngModel)]="dateRangeEnd"
                inputId="created-date-end"
                placeholder="End date"
                dateFormat="yy-mm-dd"
                showIcon
                (ngModelChange)="onEndChange($event)"
                [inputStyleClass]="'w-full px-2 py-1.5 rounded border border-surface-switch-200 bg-surface-switch-0 text-surface-switch-900 text-sm'"
              ></p-datepicker>
            </div>
          </div>

          <div class="mt-3 pt-2 text-right border-t border-surface-switch-100">
            <button
              pButton
              type="button"
              label="Clear"
              class="p-button-sm p-button-text"
              (click)="clearFilter()"
            ></button>
          </div>
        </div>
      }
    </div>

    <button
      type="button"
      class="sort-arrow inline-flex items-center justify-center p-1 -mt-1 leading-none transition-all duration-150 rounded hover:bg-surface-switch-200 hover:text-primary-500 cursor-pointer"
      [ngClass]="{
        'text-primary-600 font-semibold bg-surface-switch-200': isActiveSort,
      }"
      (click)="toggleSort(); $event.stopPropagation()"
    >
      <i
        class="pi"
        [ngClass]="{
          'pi-sort-alpha-up': sortDirection === 'asc',
          'pi-sort-alpha-down': sortDirection === 'desc',
          'pi-sort-alt': !isActiveSort,
        }"
      ></i>
    </button>
  </div>
</div>
